import axios from 'axios'
import qs from 'qs'
import wcs from '@/scripts/libs/wcs'

export class WcsCms {
  static getPdpDynamicContent = async (
    catalogId: number,
    storeId: number,
    langId: number,
    catEntryId: number,
    userCluster: string
  ) => {
    const cmsDynamicContentUrl = wcs.getEndPoint('pdpDynamicContentUrl')
    const params = { catalogId, storeId, langId, productId: catEntryId, USER_CLUSTER: userCluster }
    const url = `${cmsDynamicContentUrl}?${qs.stringify(params)}`

    const response = await axios.get(url)
    return response.data
  }

  static getPlpDynamicContent = async (
    catalogId: number,
    storeId: number,
    langId: number,
    categoryId: number,
    userCluster: string
  ) => {
    const cmsDynamicContentUrl = wcs.getEndPoint('plpDynamicContentUrl')
    const params = { catalogId, storeId, langId, categoryId, USER_CLUSTER: userCluster }
    const response = await axios.get(cmsDynamicContentUrl, { params: params })
    return response.data
  }
}
